// import {
//   countries as countriesData,
//   timeZone,
// } from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { CiEdit } from "react-icons/ci";
import {
  DatePicker,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
  InputNumber,
} from "antd";

const RateDetailsComponent = ({ rateDetails, setRateDetails, nonMandateRateDetails, setNonMandateRateDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {

  const [form] = Form.useForm();
    const { Option } = Select;

  const formDisabled = rateDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false);


  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(rateDetails).filter((value) => value !== null)
          .length === Object.values(rateDetails).length
      ) {
        form.submit();
        setRateDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setRateDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };

  const handleRevenuModelChange = (revModelValue)=>{
    if(revModelValue === 'per_port'){
        setNonMandateRateDetails(prev => ({
            revShareFactorForCustomer: null,
            revShareFactorForBreathe: null,
            isAbsoluteRevShare: null,
            absoluteRevShareAmount: null,
            MUFA:null,
            MUFChargerCount:null,
            miscRevShare: [0,0,0,0]
        }))
        const {revShareFactorForCustomer, revShareFactorForBreathe, isAbsoluteRevShare, absoluteRevShareAmount, miscRevShare,MUFA,MUFChargerCount, ...restOfRateDetails} = rateDetails
        setRateDetails({...restOfRateDetails, revenueModel: revModelValue, perPortAmount: null})
        form.setFieldValue("perPortAmount", null)
        form.setFieldValue("revenueModel", revModelValue)
    }
    else if(revModelValue === "rev_share"){
        setNonMandateRateDetails(prev => ({
            perPortAmount: null,
            MUFA:null,
            MUFChargerCount:null
        }))
        const {perPortAmount,MUFA,MUFChargerCount, ...restOfRateDetails} = rateDetails
        setRateDetails({...restOfRateDetails, revenueModel: revModelValue, revShareFactorForCustomer: null, revShareFactorForBreathe: null, isAbsoluteRevShare: false, absoluteRevShareAmount: 0, miscRevShare: [0,0,0,0]})
        form.setFieldValue("absoluteRevShareAmount", 0)
        form.setFieldValue("revenueModel", revModelValue)
        form.setFieldValue("revShareFactorForCustomer", null)
        form.setFieldValue("revShareFactorForBreathe", null)
        form.setFieldValue("isAbsoluteRevShare", false)
        form.setFieldValue("miscRevShare", [0,0,0,0])

    }else if (revModelValue === "hybrid"){
        setNonMandateRateDetails({  MUFA:null,
            MUFChargerCount:null})
             const {MUFA,MUFChargerCount, ...restOfRateDetails} = rateDetails
        // setRateDetails(prev => ({
        //     ...prev, perPortAmount: null,revenueModel: revModelValue, revShareFactorForCustomer: null, revShareFactorForBreathe: null, isAbsoluteRevShare: false, absoluteRevShareAmount: 0, miscRevShare: [0,0,0]
        // }))
        setRateDetails({...restOfRateDetails,perPortAmount: null,revenueModel: revModelValue, revShareFactorForCustomer: null, revShareFactorForBreathe: null, isAbsoluteRevShare: false, absoluteRevShareAmount: 0, miscRevShare: [0,0,0,0]})
        form.setFieldValue("perPortAmount", null)
        form.setFieldValue("absoluteRevShareAmount", 0)
        form.setFieldValue("revenueModel", revModelValue)
        form.setFieldValue("revShareFactorForCustomer", null)
        form.setFieldValue("revShareFactorForBreathe", null)
        form.setFieldValue("isAbsoluteRevShare", false)
        form.setFieldValue("miscRevShare", [0,0,0,0])
    }
    else if (revModelValue === "muf"){
      setNonMandateRateDetails((prev)=>({perPortAmount:null,isAbsoluteRevShare:null,absoluteRevShareAmount:null}))
      const {perPortAmount,isAbsoluteRevShare,absoluteRevShareAmount,...restOfRateDetails} = rateDetails;
      setRateDetails({...restOfRateDetails,revenueModel:revModelValue,revShareFactorForCustomer: null, revShareFactorForBreathe: null,miscRevShare: [0,0,0,0],MUFA:null,MUFChargerCount:null});
      form.setFieldValue("miscRevShare", [0,0,0,0])
      form.setFieldValue("revenueModel", revModelValue)
        form.setFieldValue("revShareFactorForCustomer", null)
        form.setFieldValue("revShareFactorForBreathe", null)
        form.setFieldValue("MUFA",null);
        form.setFieldValue("MUFChargerCount",null)


    }
  }


  return (
    <div className={Styles[`main-div`]}>
      
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {rateDetails?.isSectionCompleted && isApprover && isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!rateDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setRateDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <CiEdit  
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={rateDetails}
        disabled={rateDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false) }
      >

        <Form.Item
          label="Energy Cost ($/kWh)"
          name="energyCost"
          rules={[{ required: true, message: "Please enter energy cost!" }]}
        >
          <InputNumber
            placeholder={0.35}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                energyCost: value,
              }));
            }}
          />
        </Form.Item>

        <Form.Item
          label="Idle Fee ($/min)"
          name="idleFee"
          rules={[{ required: true, message: "Please enter idle fee!" }]}
        >
          <InputNumber
            placeholder={0.25}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                idleFee: value,
              }));
            }}
          />
        </Form.Item>

        <Form.Item
          label="Tax (%)"
          name="tax"
          rules={[{ required: true, message: "Please enter tax!" }]}
        >
          <InputNumber
            placeholder={0.25}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                tax: value,
              }));
            }}
          />
        </Form.Item>

        <Form.Item
          label="Rate Type"
          name="rateType"
          rules={[{ required: true, message: "Please input rate type!" }]}>
          <Select
                      // value={locationDetails?.country}
                      onChange={(value) => {
                        setRateDetails((prev) => ({
                          ...prev,
                          rateType: value,
                        }));
                      }}
                      placeholder="Rate Type"
                      allowClear
                    >
                        <Option value="fixed">Fixed Rate</Option>
                        <Option value="dynamic">Dynamic Rate</Option>

                    </Select>
        </Form.Item>

         <Form.Item
          label="Transaction Fee Amount"
          name="transactionFee"
          rules={[{ required: true, message: "Please enter transaction fee amount!" }]}
        >
          <InputNumber
            placeholder={0}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                transactionFee: value,
              }));
            }}
          />
        </Form.Item>

         <Form.Item
          label="Transaction Fee percentage (%)"
          name="transactionFeeFactor"
          rules={[{ required: true, message: "Please enter transaction fee percent!" }]}
        >
          <InputNumber
            placeholder={0}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                transactionFeeFactor: value,
              }));
            }}
          />
        </Form.Item>

        <Form.Item
          label="Revenue Model Type"
          name="revenueModel"
          rules={[{ required: true, message: "Please input revenue model type!" }]}>
          <Select
                      // value={locationDetails?.country}
                      onChange={(value) => {
                        handleRevenuModelChange(value)
                      }}
                      placeholder="Revenue Model Type"
                      allowClear
                    >
                        <Option value="rev_share">Rev Share</Option>
                        <Option value="per_port">Per Port</Option>
                        <Option value="hybrid">Hybrid</Option>
                        <Option value='muf'>MUF</Option>

                       
                    </Select>
        </Form.Item>


        
        {/* {console.log("rev shrea customer : ", rateDetails?.revShareFactorForCustomer)} */}
        <Form.Item
          label="Customer RevShare (%)"
          name="revShareFactorForCustomer"
          
          rules={[{ required: (!Object.keys(rateDetails).includes('revShareFactorForCustomer'))? false: true, message: "Please enter Customer RevShare!" }]}
        >
          <InputNumber
          disabled={formDisabled || !Object.keys(rateDetails).includes('revShareFactorForCustomer')}
            placeholder={60}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                revShareFactorForCustomer: value,
                revShareFactorForBreathe: 100 - value,
              }));
              form.setFieldValue("revShareFactorForBreathe", 100 - value);
            }}
          />
        </Form.Item>

        <Form.Item
          
          label="Breathe RevShare (%)"
          name="revShareFactorForBreathe"
          rules={[{ required: (!Object.keys(rateDetails).includes('revShareFactorForBreathe')) ? false : true, message: "Please enter Breathe RevShare!" }]}
        >
          <InputNumber
          disabled={formDisabled || !Object.keys(rateDetails).includes('revShareFactorForBreathe')}
            placeholder={60}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                revShareFactorForBreathe: value,
                revShareFactorForCustomer: 100 - value,
              }));
              form.setFieldValue("revShareFactorForCustomer", 100 - value);
            }}
          />
        </Form.Item>

        <Form.Item
          label="Per Port Amount ($/month)"
          name="perPortAmount"
          rules={[{ required:(!Object.keys(rateDetails).includes('perPortAmount'))? false : true, message: "Please enter Per Port Amount!" }]}
        >
          <InputNumber
          disabled={formDisabled || !Object.keys(rateDetails).includes('perPortAmount')}
            placeholder={60}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                perPortAmount: value,
              }));
            }}
          />
        </Form.Item>


        <Form.Item name="isAbsoluteRevShare" valuePropName="checked" >
                  <Checkbox
                  disabled={formDisabled || !Object.keys(rateDetails).includes('isAbsoluteRevShare')}
                    onChange={(e) => {
                        setRateDetails(prev => ({
                          ...prev,
                          isAbsoluteRevShare: e.target.checked
                      }));
                      
                    }}
                  >
                    {" "}
                    Is Absolute Rev Share.
                  </Checkbox>
                </Form.Item>

        <Form.Item
          label="Absolute Rev Share Amount ($/kWh)"
          name="absoluteRevShareAmount"
          rules={[{ required: rateDetails?.isAbsoluteRevShare ? true : false, message: "Please enter Absolute Rev share Amount!" }]}
        >
          <InputNumber
          disabled={formDisabled || !Object.keys(rateDetails).includes('absoluteRevShareAmount') || (rateDetails?.isAbsoluteRevShare === false)}
            placeholder={0.06}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                absoluteRevShareAmount: value,
              }));
            }}
          />
        </Form.Item>
         <Form.Item label="MUF Rate ($)" name='MUFA'>
            <InputNumber
                min={0}
                placeholder="$0.20"
                // style={{ width: '100%' }}
                disabled={formDisabled || !Object.keys(rateDetails).includes('MUFA')}
                 onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                MUFA: value,
              }));
            }}
                // value={tempRevenueModel.MUFA}
                // onChange={(value) => handleRevenueModelChange('MUFRate', value)}
            />
        </Form.Item>
        <Form.Item label = "MUF charger count" name='MUFChargerCount'>
            <InputNumber
                min={0}
                placeholder="2"
                // style={{ width: '100%' }}
                disabled={formDisabled || !Object.keys(rateDetails).includes('MUFChargerCount')}
                 onChange={(value) => {
              setRateDetails((prev) => ({
                ...prev,
                MUFChargerCount: value,
              }));
            }}
                // value={tempRevenueModel.MUFChargerCount}
                // onChange={(value) => handleRevenueModelChange('MUFChargerCount', value)}
            />
        </Form.Item>

        <div className={Styles["full-width"]}>
            <p>Miscellaneous Revenue Shares</p>
            <table className={Styles["info-table"]}>
                <thead>
                    <tr>
                        <th>Idle Fee Customer Share (%)</th>
                        <th>Unutilization Fee Customer Share (%)</th>
                        <th>Cancellation Fee Customer Share (%)</th>
                        <th>Overnight Fee Customer Share (%)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* {console.log("miscRevShare", rateDetails?.miscRevShare)} */}      
                        
                        <td><InputNumber
                            disabled={formDisabled || !Object.keys(rateDetails).includes('miscRevShare')}
                            value={rateDetails?.miscRevShare ? rateDetails?.miscRevShare[0] : 0}
                            onChange={(value) => {
                              const updatedMiscRevShare = [...(rateDetails?.miscRevShare || [0, 0, 0, 0])];
                              updatedMiscRevShare[0] = value;
                              setRateDetails((prev) => ({
                                ...prev,
                                miscRevShare: updatedMiscRevShare,
                              }));
                            }}
                            placeholder={60}
                            min={0}
                        /></td>
                        <td><InputNumber
                        disabled={formDisabled || !Object.keys(rateDetails).includes('miscRevShare')}
                            value={rateDetails?.miscRevShare ? rateDetails?.miscRevShare[1] : 0}
                            onChange={(value) => {
                              const updatedMiscRevShare = [...(rateDetails?.miscRevShare || [0, 0, 0, 0])];
                              updatedMiscRevShare[1] = value;
                              setRateDetails((prev) => ({
                                ...prev,
                                miscRevShare: updatedMiscRevShare,
                              }));
                            }}
                            placeholder={60}
                            min={0}
                        /></td>
                        <td><InputNumber
                        disabled={formDisabled || !Object.keys(rateDetails).includes('miscRevShare')}
                            value={rateDetails?.miscRevShare ? rateDetails?.miscRevShare[2] : 0}
                            onChange={(value) => {
                              const updatedMiscRevShare = [...(rateDetails?.miscRevShare || [0, 0, 0, 0])];
                              updatedMiscRevShare[2] = value;
                              setRateDetails((prev) => ({
                                ...prev,
                                miscRevShare: updatedMiscRevShare,
                              }));
                            }}
                            placeholder={60}
                            min={0}
                        /></td>
                        <td><InputNumber
                        disabled={formDisabled || !Object.keys(rateDetails).includes('miscRevShare')}
                            value={rateDetails?.miscRevShare ? rateDetails?.miscRevShare[3] : 0}
                            onChange={(value) => {
                              const updatedMiscRevShare = [...(rateDetails?.miscRevShare || [0, 0, 0, 0])];
                              updatedMiscRevShare[3] = value;
                              setRateDetails((prev) => ({
                                ...prev,
                                miscRevShare: updatedMiscRevShare,
                              }));
                            }}
                            placeholder={60}
                            min={0}
                        /></td>
                    </tr>
                </tbody>
            </table>
            </div>

        







        {isApprover && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(rateDetails).filter((value) => value !== null)
                .length /
                Object.values(rateDetails).length <
                1 || rateDetails?.isSectionCompleted
            }
            onChange={(e) => {
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default RateDetailsComponent;
